import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { pinsQueryKeys } from '../constants'

export const useGetProjectPinsQuery = ({
  projectId,
  page = 0,
  size = 10,
  filterId = null,
  options
}) => {
  const handleQuery = async () => {
    const config = {
      method: 'get',
      params: {
        page,
        size,
        filterId
      }
    }
    const { data } = await api(`/api/v2/projects/${projectId}/pins`, config)

    return data
  }

  return useQuery({
    queryKey: [pinsQueryKeys.GET_PROJECT_PINS, projectId, page, size, filterId],
    queryFn: handleQuery,
    retry: 0,
    enabled: !!projectId,
    ...options
  })
}
